import React from 'react';
import { normalizeStateCode } from '../utils/wizardFieldValidation';

export const PROPERTY_ADDRESS_PLACEHOLDERS = {
  street: 'Enter street number and street name (e.g., 123 Main St)',
  city: 'Enter city (e.g., Oklahoma City)',
  state: 'State (e.g., OK)',
  zip: 'ZIP code (e.g., 73107)',
};

export const PROPERTY_ADDRESS_QUESTION = 'What is the property address?';

export function localityFromAddress(values = {}) {
  const city = String(values.property_address_city || '').trim();
  const state = String(values.property_address_state || '').trim();
  const zip = String(values.property_address_zip_code || '').trim();
  return [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

export function withAppendixALocation(values = {}) {
  const street = String(values.property_address || values.q_p1_280_text || '').trim();
  const locality = localityFromAddress(values) || String(values.q_p1_291_text || '').trim();
  return {
    ...values,
    q_p1_280_text: street,
    q_p1_291_text: locality,
  };
}

/**
 * Purchase-agreement address entry. Every form that asks for a property
 * address must use this control — street, city, state, ZIP.
 */
export default function PropertyAddressFields({
  values = {},
  onChange,
  placeholders = PROPERTY_ADDRESS_PLACEHOLDERS,
  streetKey = 'property_address',
  cityKey = 'property_address_city',
  stateKey = 'property_address_state',
  zipKey = 'property_address_zip_code',
}) {
  return (
    <div className="wizard-address">
      <input
        type="text"
        aria-label="Street address"
        value={values[streetKey] || ''}
        onChange={(event) => onChange(streetKey, event.target.value)}
        placeholder={placeholders.street}
        className="wizard-input"
      />
      <input
        type="text"
        aria-label="City"
        value={values[cityKey] || ''}
        onChange={(event) => onChange(cityKey, event.target.value)}
        placeholder={placeholders.city}
        className="wizard-input"
      />
      <input
        type="text"
        aria-label="State"
        value={values[stateKey] || ''}
        onChange={(event) => onChange(stateKey, normalizeStateCode(event.target.value))}
        placeholder={placeholders.state}
        className="wizard-input"
        maxLength={2}
      />
      <input
        type="text"
        aria-label="ZIP code"
        value={values[zipKey] || ''}
        onChange={(event) => onChange(zipKey, event.target.value.replace(/\D/g, '').slice(0, 5))}
        placeholder={placeholders.zip}
        className="wizard-input"
        inputMode="numeric"
        maxLength={5}
      />
    </div>
  );
}
